import React from 'react';
import { getDodDiff } from '@src/components/metrics-panel-hz/utils/calculateDodTotal';
import { getMetricFilterMetric } from './utils';
import { get } from 'lodash';
import { Trend } from '@components/common';
import { StyledTrendWrapper } from './styled';
import { Tooltip } from 'antd';
import humanizeUtil from '@utils/humanizeUtil';

const DoDTrend = ({ rowData, column, cellData, unit }) => {
  const { metric, metricInfo } = column;
  const isReverseMetric = get(column, ['errorMetricInfo', 'reverse'], metricInfo.reverse);

  const dodValue = rowData[getMetricFilterMetric(metric)];
  const trend = getDodDiff(cellData, dodValue);
  const { humanizedNumber: humanizedDoDNumber, humanizedUnit: humanizedDoDUnit } = humanizeUtil(
    dodValue,
    metric,
    unit as string,
  );
  const dodHumanized = isNaN(dodValue) ? 'NA' : `${humanizedDoDNumber} ${humanizedDoDUnit}`;

  return (
    <Tooltip title={dodHumanized}>
      <StyledTrendWrapper>
        <Trend
          value={trend}
          style={{
            display: 'flex',
            paddingLeft: 4,
            fontSize: '11px',
            alignItems: 'center',
            justifyContent: 'end',
            fontWeight: 400,
          }}
          reverse={isReverseMetric}
        />
      </StyledTrendWrapper>
    </Tooltip>
  );
};

export default DoDTrend;
